import React, { useState, Fragment } from 'react';
import styled from '@emotion/styled';

const Link = styled('span')`
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
  color: #7e57c2;
  padding: 10px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #dee2e6;
`;

const DisplayMoreWrapper = (props) => {
  const { isTable = false, array, thead, length = 100, btnClassName } = props;

  const [count, setCount] = useState(0);

  const changeCount = () => {
    setCount(count + 1);
  };

  if (!array && isTable)
    return (
      <table className="table table-centered">
        {thead}
        <tbody></tbody>
      </table>
    );

  return (
    <>
      {isTable ? (
        <>
          <table className="table table-centered">
            {thead}
            <tbody>
              {array.length
                ? array
                    .slice(0, length * count + 10)
                    .map((item, itemIndex) => (
                      <Fragment key={itemIndex}>
                        {props.children({ ...props, item: item, itemIndex: itemIndex })}
                      </Fragment>
                    ))
                : null}
            </tbody>
          </table>
          {array.length > 10 && array.length > length * count + 10 ? (
            <Link onClick={changeCount}>Показать ещё позиции</Link>
          ) : null}
        </>
      ) : (
        <>
          {array.length
            ? array
                .slice(0, length * count + 10)
                .map((item, itemIndex) => (
                  <Fragment key={itemIndex}>
                    {props.children({ ...props, item: item, itemIndex: itemIndex })}
                  </Fragment>
                ))
            : null}
          {array.length > 10 && array.length > length * count + 10 ? (
            <Link className={btnClassName} onClick={changeCount}>
              Показать ещё позиции
            </Link>
          ) : null}
        </>
      )}
    </>
  );
};

export default DisplayMoreWrapper;
